import { Component, Input, OnInit, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services/filter.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { AssetOverviewService } from '../../../services/asset-overview.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { TranslocoService } from '@jsverse/transloco';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GlobaltrackProductsModalComponent } from '../../modals/globaltrack-products-modal/globaltrack-products-modal.component';

const TOTAL_PRODUCT_CATEGORIES = 4;

@Component({
  selector: 'app-products-installed-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './products-installed-widget.component.html',
  styleUrl: './products-installed-widget.component.scss'
})
export class ProductsInstalledWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input({ required: true }) assetId!: number;

  hasError: boolean = false;
  errorMessage: string = '';

  private assetOverviewService = inject(AssetOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);
  private readonly transloco: TranslocoService = inject(TranslocoService);
  private modalService = inject(NgbModal);

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);

    this.title = this.transloco.translate('assetOverview.widgets.productsInstalled');
    this.isLoading = true;
    this.value = 0;
  }

  ngOnInit(): void {
    void this.loadProductsInstalledAsync();
  }

  protected override async onFilterChangeAsync(): Promise<void> {
  }

  public override formatValue(value: number): string {
    return this.transloco.translate('assetOverview.widgets.valueOfTotal', { value, total: TOTAL_PRODUCT_CATEGORIES });
  }

  openProductsModal(): void {
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      windowClass: 'globaltrack-products-modal'
    };
    const modalRef = this.modalService.open(GlobaltrackProductsModalComponent, modalOptions);
    modalRef.componentInstance.assetId = this.assetId;
  }

  private async loadProductsInstalledAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;
    this.errorMessage = '';

    try {
      this.cancelSubject.next();
      const response = await this.assetOverviewService.getProductsInstalled({ assetId: this.assetId }, this.cancelSubject);
      this.value = response?.data?.totalValue ?? 0;

      const percentageChange = response?.data?.percentageChange;
      if (percentageChange !== undefined && percentageChange !== null) {
        this.percentageDifference = percentageChange;
      }

      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }
}
